import {
    AnyAction,
    CaseReducer,
    createAsyncThunk,
} from '@reduxjs/toolkit'
import {
    NinchatActionType,
    NinchatRemoveMemberAction,
} from 'api/types/actions'
import ninchatClient, {
    NinchatActionParams,
    NinchatClientPromiseValue,
} from 'api/NinchatClient'

import {NinchatState} from 'api/types'
import {channelMemberParted} from 'api/event/channelMemberParted'
import {queueMemberParted} from 'api/event/queueMemberParted'
import {realmMemberParted} from 'api/event/realmMemberParted'

const actionTypePrefix = 'NINCHAT/action'

type MetaReducerAsyncThunkConfig = {fulfilledMeta: {reducer: CaseReducer}}

export const removeMember = createAsyncThunk<NinchatClientPromiseValue, NinchatActionParams<NinchatRemoveMemberAction>, MetaReducerAsyncThunkConfig>(
    `${actionTypePrefix}/${NinchatActionType.NinchatRemoveMemberAction}`,
    async (arg, thunkAPI) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatRemoveMemberAction

        /* eslint-disable indent, multiline-ternary */
        const meta = {
            reducer:
                params.channel_id ? channelMemberParted :
                params.queue_id ? (state: NinchatState, action: AnyAction) => queueMemberParted(state, action) :
                params.realm_id ? realmMemberParted :
                () => undefined,
        }
        /* eslint-enable */
        try {
            const reply = await ninchatClient.send(params)

            return thunkAPI.fulfillWithValue(reply, meta)
        } catch (err) {
            return thunkAPI.rejectWithValue(err)
        }
    },
)
